import {Brick, ErrorFlow, registerBrick} from 'olympe';

/**
 * This brick opens a URL or HTML code in a new tab.
 */
export default class OpenInANewTab extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} uRLOrHTML
     * @param {function()} forwardEvent
     * @param {function(*)} setErrorFlow
     */
    update($, [uRLOrHTML], [forwardEvent, setErrorFlow]) {
        try {
            let url;
            try {
                // Try to create a URL object (string has to be a valid URL
                url = new URL(uRLOrHTML);
            } catch (_) {
                // Create a Blob from the HTML string
                const blob = new Blob([uRLOrHTML], {type: 'text/html'});
                url = URL.createObjectURL(blob);
            }

            window.open(url, '_blank');
            forwardEvent();
        } catch (e) {
            console.error(e);
            setErrorFlow(ErrorFlow.create(`Can't open the URL/HTML code: ${e}`, 1));
        }
    }
}

registerBrick('019e889e5a93a6ca4c81', OpenInANewTab);
